/**
 * MissMarker Component
 *
 * Visual indicator for a missed attack on the grid.
 * Displays a distinctive blue dot symbol with animation.
 *
 * Props:
 * - size: Size variant (small, medium, large)
 * - className: Custom CSS classes
 */

export default function MissMarker({ size = 'medium', className = '' }) {
  // Size mappings with descriptive class names for testing
  const sizeClasses = {
    small: 'text-sm small',
    medium: 'text-2xl',
    large: 'text-4xl large',
  };

  const textSize = sizeClasses[size] || sizeClasses.medium;

  return (
    <div
      data-testid="miss-marker"
      role="img"
      aria-label="Miss"
      className={`flex items-center justify-center text-blue-400 transition-all duration-200 ${textSize} ${className}`}
    >
      •
    </div>
  );
}
